import { createFileRoute } from '@tanstack/react-router'
import { sessionQuery } from '~/features/training/queries'
import { loaderScope } from '~/lib/session'
import { SessionPage } from '~/features/training/SessionPage'

export const Route = createFileRoute('/_app/training/$sessionId')({
  loader: async ({ context, params }) => {
    const scope = await loaderScope(context.queryClient)
    if (!scope) return
    // A missing session renders the page's own error state, not the router's.
    await context.queryClient.ensureQueryData(sessionQuery(scope.teamId, scope.season, params.sessionId)).catch(() => undefined)
  },
  component: function Session() {
    return <SessionPage sessionId={Route.useParams().sessionId} />
  },
})
